export const DEFAULT_HIDDEN_INTERNAL_ORDER_STATUSES = new Set([
  "checkout_initiated",
]);

export function normalizeOrderStatus(status: unknown): string {
  return String(status ?? "").trim().toLowerCase();
}

export function isHiddenInInternalOrderTablesByDefault(status: unknown): boolean {
  return DEFAULT_HIDDEN_INTERNAL_ORDER_STATUSES.has(normalizeOrderStatus(status));
}
